import { AbstractControl, ValidatorFn } from '@angular/forms';

export class DndValidators {
  static emailListValidator(emailListSeperatorsRegExp: RegExp = /(\s*[,|;]\s*)/igm): ValidatorFn {
    const result = (control: AbstractControl): {
      [key: string]: any;
    } => {
      let emailList: string[] = [];
      let notValidEmailList: string[] = [];
      let emailListForTest: string = control.value;
      emailListForTest = emailListForTest.replace(emailListSeperatorsRegExp, ';');
      //replace ; at the end
      emailListForTest = emailListForTest.replace(new RegExp(';*$'), '');
      if (emailListForTest && emailListForTest.length) {
        emailList = emailListForTest.split(/;/igm);
        for (let email of emailList) {
          email = email.trim();
          if (!this.isEmailValid(email)) {
            notValidEmailList.push(email);
          }
        }
      }
      return (notValidEmailList && notValidEmailList.length) ? { 'notValidEmailList': { value: notValidEmailList } } : null;
    };
    return result;
  }
  static isEmailValid(email: string): boolean {
    const validEmailRegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'igm');
    let isValid: boolean = validEmailRegExp.test(email);
    return isValid;
  }
}
